import React, { useState, } from 'react';
import { IconButton, Grid, Box, } from '@mui/material';
import { OrderedListOutlined, } from '@ant-design/icons/lib/icons';
import SearchIcon from '@mui/icons-material/Search';
import MainSelect from '../../../General/MainSelect';
import MainInput from '../../../General/MainInput';
import SpinnerSmall from '../../../SpinnerLoad/SpinnerSmall';
import { filterData, sortDataListSimple, } from '../../../../../utils/function';
import { colors } from '../../../../../assets/colors';
import _ from 'lodash';

const columns = [
    { id: 'sel', label: 'Sel.', width: 10, align: 'center', },
    { id: 'des', label: 'Des.', width: 10, align: 'center', },
    { id: 'codSghh', label: 'Código', width: 50, align: 'left', },
    { id: 'trabajador', label: 'Nombre', width: 150, align: 'left', },
];

const Planning = (props) => {
    const { openSmall, shift, id_usuarioLogin, id_personaLogin, dataWorkers, fechaDesde, setFechaDesde, fechaHasta, setFechaHasta, shiftPlan, setShiftPlan,
        workerPlan, setWorkerPlan, workerPlanDesc, setWorkerPlanDesc, infoArea, semana, diaDescanso, setDiaDescanso, primerDiaG, ultimoDiaG
    } = props;

    const [search, setSearch] = useState('');

    let resultSearch = filterData(dataWorkers, search, ['codSghh', 'trabajador']);
    /** inicio ordenamiento de columnas */
    const [sortConfigTable, setSortConfigTable] = useState({ key: null, direction: "ascending", });
    const handleSortTable = (key) => {
        let direction = "ascending";
        if (sortConfigTable && sortConfigTable.key === key && sortConfigTable.direction === "ascending") {
            direction = "descending";
        }
        setSortConfigTable({ key, direction });
    };
    const sortedData = sortDataListSimple(resultSearch, sortConfigTable);
    /** fin ordenamiento de columnas */

    const genNewItem = (info, tipPla) => {
        let item = {
            "persona_id": +info.id_persona,
            "turno_id": +shiftPlan,
            "area_id": +infoArea?.value,
            "supervisor_id": id_personaLogin,
            "tipPla_id": tipPla,
            "usuario_id": id_usuarioLogin,
            "codSghh": info.codSghh
        }
        return item;
    }

    const handleChangeCheck = (value, p_worker) => {
        let updWorkerPlan = _.cloneDeep(workerPlan);
        if (value === false) {
            updWorkerPlan = updWorkerPlan?.filter(e => +e.persona_id !== +p_worker.id_persona);
        } else {
            let newItem = genNewItem(p_worker, 1);
            updWorkerPlan = updWorkerPlan?.filter(e => +e.id_persona !== +p_worker.id_persona);
            updWorkerPlan.push(newItem)
        }

        return setWorkerPlan(updWorkerPlan);
    }

    const handleChangeCheckDes = (value, p_worker) => {
        let updWorkerPlanDesc = _.cloneDeep(workerPlanDesc);
        if (value === false) {
            updWorkerPlanDesc = updWorkerPlanDesc?.filter(e => +e.persona_id !== +p_worker.id_persona);
        } else {
            let newItem = genNewItem(p_worker, 2);
            updWorkerPlanDesc = updWorkerPlanDesc?.filter(e => +e.persona_id !== +p_worker.id_persona);
            updWorkerPlanDesc.push(newItem);
        }
        return setWorkerPlanDesc(updWorkerPlanDesc);
    }

    const handleChangeCheckGeneral = (e) => {
        let updWorkerPlan = [];
        if (e.target.checked === true) {
            dataWorkers?.forEach((element) => {
                let newItem = genNewItem(element, 1);
                updWorkerPlan.push(newItem)
            });
        }
        return setWorkerPlan(updWorkerPlan);
    }

    const handleChangeCheckGeneralDesc = (e) => {
        let updWorkerPlan = [];
        if (e.target.checked === true) {
            dataWorkers?.forEach((element) => {
                let newItem = genNewItem(element, 2);
                updWorkerPlan.push(newItem)
            });
        }

        return setWorkerPlanDesc(updWorkerPlan);
    }

    return (
        <Grid container >
            <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'row', alignItems: 'end', }} marginTop={'1rem'}                >
                <Box width={'90%'}                    >
                    <MainInput
                        placeholder={'Buscar trabajador'}
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                </Box>
                <IconButton aria-label="trabajador" color="primary" size='small' sx={{ marginTop: 2, border: `solid 0.05rem ${colors.secondary.hex}` }}>
                    <SearchIcon fontSize={'small'} />
                </IconButton>
            </Grid>

            <Grid item xs={12} marginTop={'1rem'}>
                <SpinnerSmall open={openSmall} />
                <Box className='page-body-main'>
                    <Box className='page-body-table page-body-table__modal table-responsive-md' sx={{ height: '45vh !important' }}>
                        <table className="table table-hover table-striped table-bordered table-sm">
                            <thead className='sticky-top table-warning'>
                                <tr>
                                    {columns.map((column) => (
                                        <th
                                            scope="col"
                                            key={column.id}
                                            style={{
                                                textAlign: column.align,
                                                width: column.width,
                                                maxWidth: column.width,
                                                cursor: 'pointer',
                                            }}
                                            onClick={() => handleSortTable(column.id)}
                                        >
                                            {(column.id === 'sel' || column.id === 'des') ?
                                                <>
                                                    <label htmlFor={`checkbox-rect-header` + column.label} >{column.label}</label>
                                                    <input type="checkbox"
                                                        name="check"
                                                        id={`checkbox-rect-header` + column.label}
                                                        className={'checkbox-rect-header'}
                                                        onChange={column.id === 'sel' ?
                                                            handleChangeCheckGeneral :
                                                            handleChangeCheckGeneralDesc}
                                                    />
                                                </>
                                                : <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                    <div style={{ marginRight: 'auto' }}>{column.label}</div>
                                                    <div><OrderedListOutlined style={{ paddingBottom: 2 }} /></div>
                                                </div>}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody className="table-group-divider">
                                {sortedData?.map((work, indexRow) => {
                                    return (
                                        <tr key={"row" + indexRow}>
                                            {columns.map((column, indexColumn) => {
                                                const value = work[column.id];
                                                return (
                                                    <td key={'col' + indexColumn} align={column.align}>
                                                        {column.id === 'desSede' ?
                                                            (work?.sede?.desSede) :
                                                            (column.id === 'sel' || column.id === 'des') ?
                                                                <div className="checkbox-custom" style={{ display: 'flex', justifyContent: 'center' }}>
                                                                    <input
                                                                        type="checkbox"
                                                                        name="check"
                                                                        id={
                                                                            column.id === 'sel' ?
                                                                                (`checkbox-rect` + work.id_persona) :
                                                                                (`checkbox-rect-des` + work.id_persona)
                                                                        }
                                                                        checked={
                                                                            column.id === 'sel' ?
                                                                                (workerPlan?.find(e => +e.persona_id === +work.id_persona) ? true : false) :
                                                                                (workerPlanDesc?.find(e => +e.persona_id === +work.id_persona) ? true : false)
                                                                        }
                                                                        onChange={(e) =>
                                                                            column.id === 'sel' ?
                                                                                handleChangeCheck(e.target.checked, work) :
                                                                                handleChangeCheckDes(e.target.checked, work)
                                                                        }
                                                                    />
                                                                    <label htmlFor={
                                                                        column.id === 'sel' ?
                                                                            (`checkbox-rect` + work.id_persona) :
                                                                            (`checkbox-rect-des` + work.id_persona)
                                                                    }></label>
                                                                </div>
                                                                : value}
                                                    </td>
                                                );
                                            })}
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </Box>
                </Box >
            </Grid>

            <Grid item xs={3} marginTop={'0.5rem'}>
                <MainSelect
                    title={'Turno'}
                    placeholder={'Selecionar turno'}
                    options={shift}
                    value={Number(shiftPlan)}
                    onChange={(value, e) => { setShiftPlan(value) }}
                    name='turno'
                />
            </Grid>

            <Grid item xs={3} marginTop={'0.5rem'}>
                <MainInput
                    title={'Fecha desde'}
                    value={fechaDesde}
                    name={'FecDes'}
                    type={'date'}
                    onChange={(e) => setFechaDesde(e.target.value)}
                    propsInput={{
                        min: primerDiaG,
                        max: ultimoDiaG,
                        type: 'date',
                    }}
                />
            </Grid>

            <Grid item xs={3} marginTop={'0.5rem'}>
                <MainInput
                    title={'Fecha hasta'}
                    value={fechaHasta}
                    name={'FecDes'}
                    type={'date'}
                    onChange={(e) => setFechaHasta(e.target.value)}
                    propsInput={{
                        min: primerDiaG,
                        max: ultimoDiaG,
                        type: 'date',
                    }}
                />
            </Grid>

            <Grid item xs={3} marginTop={'0.5rem'}>
                <MainSelect
                    title={'Descanso'}
                    placeholder={'Selecionar descanso'}
                    options={semana}
                    value={diaDescanso}
                    onChange={(value, e) => { setDiaDescanso(value) }}
                    name='descanso'
                />
            </Grid>
        </Grid>
    );
};

export default Planning;